// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".casino-info-view[data-v-8e05cd22]{background-color:#02a179;font-size:0}.casino-info-view .casino-image-group[data-v-8e05cd22]{border-top:0;border-left:0;overflow:hidden;padding:0 0 0 0}.casino-info-view .casino-image[data-v-8e05cd22]{width:50%;float:left;border-right:0;border-bottom:0;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0 0 0 0}", ""]);
// Exports
module.exports = exports;
